module.exports = __webpack_public_path__ + "d24211bca59ca7534e0e4ac0b5aa52f6.jpg";